require("./componentes/validacion-formularios")
require("./theme/general")
require("./theme/sesion")
require("./theme/inicio")
require("./componentes/filtros")
require("./componentes/modal-filtros")
require("./componentes/modal-calificar")
require("./componentes/modal-recuperar-acceso")
require("./componentes/modal-restablecer-acceso")
require("./theme/terraza/publica-terraza")
require("./theme/mensajes")
require("./componentes/loader")
require("./theme/terrazas")
require("./theme/terrazas-mapa")
require("./theme/terraza-detalle")
require("./theme/checkout")
require("./theme/checkout-agregar-servicios")
require("./theme/reservacion-detalle")
require("./theme/contacto")

//cuenta
require('./theme/cuenta/eventos')
require('./theme/cuenta/datos-personales')
require('./theme/cuenta/cambiar-acceso')

//anfitrion
require('./theme/anfitrion/reservas')
require('./theme/anfitrion/terrazas')
require('./theme/anfitrion/calendario')
require('./componentes/anfitrion/modal-calendario-reserva')

//planes
require('./theme/anfitrion/planes')
require('./theme/anfitrion/planes-checkout')
